'use client';

import FaIcon from '@/components/icon/FaIcon/FaIcon';
import { faChevronLeft, faChevronRight, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import styles from './CarouselModal.module.scss';

function CarouselModal({
  initShowIndex,
  isOpen,
  close,
  childrenArr,
}: {
  initShowIndex: number;
  isOpen: boolean;
  close: () => void;
  childrenArr: React.ReactNode[];
}) {
  const [showChildren, setShowChildren] = useState(childrenArr[initShowIndex]);

  useEffect(() => {
    setShowChildren(childrenArr[initShowIndex]);
  }, [initShowIndex, childrenArr]);

  const onNext = () => {
    const currentIndex = childrenArr.indexOf(showChildren);
    const nextIndex = currentIndex + 1;
    if (nextIndex < childrenArr.length) {
      setShowChildren(childrenArr[nextIndex]);
      return;
    }
    setShowChildren(childrenArr[0]);
  };

  const onPrev = () => {
    const currentIndex = childrenArr.indexOf(showChildren);
    const prevIndex = currentIndex - 1;
    if (prevIndex >= 0) {
      setShowChildren(childrenArr[prevIndex]);
      return;
    }
    setShowChildren(childrenArr[childrenArr.length - 1]);
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={close}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button type='button' className={styles.closeButton} onClick={close}>
          <FaIcon icon={faXmark} />
        </button>
        <div className={styles.contentsContainer}>
          <div className={styles.contentsItem}>{showChildren}</div>
        </div>
        {isOpen && (
          <div className={styles.navButtonsContainer}>
            <button type='button' className={styles.navButton} onClick={onPrev}>
              <FaIcon icon={faChevronLeft} />
            </button>
            <button type='button' className={styles.navButton} onClick={onNext}>
              <FaIcon icon={faChevronRight} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default CarouselModal;
